import React from 'react';
import { Drawer, InfoUser } from '../../components';
import { useStyles } from '../../services/material-ui';

const ViewUser: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <InfoUser />
      </main>
    </div>
  );
};

export default ViewUser;
